<script>
  export let item;
</script>

<div class="stats-item">
  <h2 class="stats-item__title">{item.title}</h2>
  <p class="stats-item__desc text-small">{item.desc}</p>
</div>

<style lang="scss">
  .stats-item {
    text-align: center;
    padding: 3rem 6rem;

    @include resp-max('m') {
      padding: 1rem 6rem;
    }

    @include resp-max('s') {
      padding: 1rem 2rem;
    }

    &__title {
      color: var(--aqua-1);
    }

    &__desc {
      color: var(--royal-light);
    }
  }
</style>
